import React from 'react';
import { excluded, included } from './assets';

type Props = {
  value?: string;
  firstPlanFeature?: boolean;
  secondPlanFeature?: boolean;
  isTitle?: boolean;
  isPlanDetails?: boolean;
  isSubsection?: boolean;
  isLastRow?: boolean;
};

export const BillingTableRow: React.FC<Props> = ({
  value = '',
  firstPlanFeature = false,
  secondPlanFeature = false,
  isTitle = false,
  isPlanDetails = false,
  isSubsection = false,
}) => {
  const defineFeatureStatusImg = () => {
    let firstPlanImgResult = '';
    let secondPlanImgResult = '';

    if (!isTitle && !isPlanDetails && !isSubsection) {
      if (firstPlanFeature) {
        firstPlanImgResult = included;
      } else {
        firstPlanImgResult = excluded;
      }

      if (secondPlanFeature) {
        secondPlanImgResult = included;
      } else {
        secondPlanImgResult = excluded;
      }
    }

    return { firstPlanImgResult, secondPlanImgResult };
  };

  const { firstPlanImgResult, secondPlanImgResult } = defineFeatureStatusImg();

  const openContactCenter = () => {
    window.open('https://www.substrata.me/contact', '_blank');
  };

  const attrs = {
    wrapper: {
      className: 'bill-row',
    },

    rowName: {
      className: 'bill-row-name',
    },

    featureStatus: {
      wrapper: {
        className: 'bill-row__feature-cell',
      },

      firstPlan: {
        img: {
          className: 'bill-row__feature-cell-img',
          src: firstPlanImgResult,
        },

        text: {
          className: 'bill-row__feature-cell-text',
        },
      },

      secondPlan: {
        img: {
          className: 'bill-row__feature-cell-img',
          src: secondPlanImgResult,
        },

        text: {
          className: 'bill-row__feature-cell-text',
        },
      },
    },

    titleRow: {
      emptyValue: {
        className: 'empty bill-row__title-cell',
      },

      titleCell: {
        wrapper: {
          className: 'bill-row__title-cell',
        },

        value: {
          className: 'bill-row__title-cell-value',
        },

        description: {
          className: 'bill-row__title-cell-description',
        },
      },
    },

    planDetails: {
      wrapper: {
        className: 'subsection bill-row',
      },

      rowName: {
        className: 'bold bill-row-name',
      },

      currentPlan: {
        className: 'bill-row__feature-cell-current-plan',
      },

      contactUs: {
        className: 'bill-row__feature-cell-contact-us',
        onClick: openContactCenter,
      },
    },

    subsectionRow: {
      className: 'subsection bill-row',
    },
  };

  const featureRow = (
    <div {...attrs.wrapper}>
      <div {...attrs.rowName}>{value}</div>
      <div {...attrs.featureStatus.wrapper}>
        {value === 'Team Members' ? (
          <div {...attrs.featureStatus.firstPlan.text}>1-10</div>
        ) : (
          <img {...attrs.featureStatus.firstPlan.img} alt="" />
        )}
      </div>
      <div {...attrs.featureStatus.wrapper}>
        {value === 'Team Members' ? (
          <div {...attrs.featureStatus.secondPlan.text}>Custom</div>
        ) : (
          <img {...attrs.featureStatus.secondPlan.img} alt="" />
        )}
      </div>
    </div>
  );

  const titleRow = (
    <div {...attrs.wrapper}>
      <div {...attrs.titleRow.emptyValue} />
      <div {...attrs.titleRow.titleCell.wrapper}>
        <div {...attrs.titleRow.titleCell.value}>PRO</div>
        <div {...attrs.titleRow.titleCell.description}>
          Ideal for individuals / small teams
        </div>
      </div>
      <div {...attrs.titleRow.titleCell.wrapper}>
        <div {...attrs.titleRow.titleCell.value}>ENTERPRISE</div>
        <div {...attrs.titleRow.titleCell.description}>
          For Large revenue teams
        </div>
      </div>
    </div>
  );

  const planDetailsRow = (
    <div {...attrs.planDetails.wrapper}>
      <div {...attrs.planDetails.rowName}>Plan Details</div>
      <div {...attrs.featureStatus.wrapper}>
        <div {...attrs.planDetails.currentPlan}>Current Plan</div>
      </div>
      <div {...attrs.featureStatus.wrapper}>
        <div {...attrs.planDetails.contactUs}>Contact us</div>
      </div>
    </div>
  );

  const subsectionRow = <div {...attrs.subsectionRow}>{value}</div>;

  const renderRow = () => {
    let result = <></>;

    if (isTitle) {
      result = titleRow;
    } else if (isPlanDetails) {
      result = planDetailsRow;
    } else if (isSubsection) {
      result = subsectionRow;
    } else {
      result = featureRow;
    }

    return result;
  };

  const rowToShow = renderRow();

  return rowToShow;
};
